import { ErrorResponse } from "../../../utils/types/generals"

export type StartActivity = {
    code: CodeStartActivity,
    message: string
} & ErrorResponse

export enum CodeStartActivity {
    SUCCESS = '01'
}